import { Group, Text } from '@mantine/core';
import { IconAlertTriangle, IconCircleCheck, IconCircleX, IconClockOff } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { ProposedActionStatus } from '../chat/types';

type Props = {
  status?: ProposedActionStatus;
  failureReason?: string | null;
  deniedLabel?: string;
};

export function ProposalDecidedLine({ status, failureReason, deniedLabel = 'Denied' }: Props) {
  const iconProps = { size: 16, stroke: 1.5, 'aria-hidden': true } as const;
  switch (status) {
    case 'APPLIED':
      return (
        <Group gap="xxs" align="center">
          <IconCircleCheck {...iconProps} color="var(--mantine-color-success-7)" />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="success.8">
            Approved and applied
          </Text>
        </Group>
      );
    case 'DENIED':
      return (
        <Group gap="xxs" align="center">
          <IconCircleX {...iconProps} color="var(--mantine-color-gray-6)" />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.7">
            {deniedLabel}
          </Text>
        </Group>
      );
    case 'FAILED':
      return (
        <Group gap="xxs" align="flex-start" wrap="nowrap">
          <IconAlertTriangle {...iconProps} color="var(--mantine-color-warning-7)" />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="warning.8">
            {failureReason
              ? `Approved but not applied: ${failureReason}`
              : 'Approved but not applied'}
          </Text>
        </Group>
      );
    case 'SUPERSEDED':
      return (
        <Group gap="xxs" align="center">
          <IconClockOff {...iconProps} color="var(--mantine-color-gray-6)" />
          <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.7">
            This proposal has expired
          </Text>
        </Group>
      );
    default:
      return null;
  }
}
